module.exports = __webpack_public_path__ + "img/employees.c6db5142.svg";